"use client";

import { useState, useEffect } from "react";
import axios from "axios";
import ConfirmationDialog from "../components/ConfirmationDialog";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AllOrderMedium = () => {
  const [selectedItems, setSelectedItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [orderMediums, setOrderMediums] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [newMedium, setNewMedium] = useState({ name: "" });
  const [editMedium, setEditMedium] = useState({ id: "", name: "" });
  const [mediumToDelete, setMediumToDelete] = useState(null);

  useEffect(() => {
    fetchMediums();
  }, []);

  const fetchMediums = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `https://logicx.premierlam.com/api/get-pixel-medium`,
        {
          headers: {
            authorization: localStorage.getItem("accessToken"),
          },
        }
      );
      setOrderMediums(response.data.data || []);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddMedium = async (e) => {
    e.preventDefault();
    try {
      setIsSubmitting(true);
      await axios.post(
        `https://logicx.premierlam.com/api/add-pixel-medium`,
        { medium_name: newMedium.name },
        {
          headers: {
            authorization: localStorage.getItem("accessToken"),
            "Content-Type": "application/json",
          },
        }
      );

      await fetchMediums();
      setIsAddDialogOpen(false);
      setNewMedium({ name: "" });
       toast.success("Order medium added successfully!");
    } catch (err) {
      console.log(err);
        toast.error(err.response?.data?.message || "Failed to add medium");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleEditMedium = async (e) => {
    e.preventDefault();
    alert("Edit API will be added later");
    setIsEditDialogOpen(false);
  };

  const handleDeleteConfirm = async () => {
    alert("Delete API will be added later");
    setIsDeleteDialogOpen(false);
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedItems(orderMediums.map((v) => v.id));
    } else {
      setSelectedItems([]);
    }
  };

  const handleSelectItem = (id) => {
    setSelectedItems((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const filteredMediums = orderMediums.filter((m) =>
    m.medium_name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  return (
    <> <ToastContainer position="top-right" autoClose={3000} />
    <div className="min-h-screen bg-gray-50 p-2">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex justify-between items-start mb-6">
          <div>
            <h1 className="text-2xl font-semibold text-gray-900 mb-1">
              Order Mediums
            </h1>
            <p className="text-gray-500">Manage your order medium list</p>
          </div>
          <button
            onClick={() => setIsAddDialogOpen(true)}
            className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
            Add Order Medium
          </button>
        </div>

        {/* Table Container */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">

          {/* Search */}
          <div className="relative mb-6">
            <svg
              className="w-5 h-5 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
            <input
              type="text"
              placeholder="Search order medium"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 w-64"
            />
          </div>

          {/* Table */}
          <div className="overflow-x-auto">
            {isLoading ? (
              <div className="flex justify-center items-center py-8">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500"></div>
              </div>
            ) : (
              <table className="w-full">
                <thead>
                  <tr className="border-b border-gray-200">
                    <th className="text-left py-3 px-4 w-12">
                      <input
                        type="checkbox"
                        checked={selectedItems.length === orderMediums.length}
                        onChange={handleSelectAll}
                        className="rounded border-gray-300 text-orange-500"
                      />
                    </th>
                    <th className="text-left py-3 px-4 text-sm font-medium text-gray-600">Medium Name</th>
                    <th className="text-left py-3 px-4 text-sm font-medium text-gray-600">Created On</th>
                    <th className="text-left py-3 px-4 text-sm font-medium text-gray-600">Added By</th>
                    <th className="text-left py-3 px-4 text-sm font-medium text-gray-600">Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {filteredMediums.map((m) => (
                    <tr key={m.id} className="border-b border-gray-100 hover:bg-gray-50">
                      <td className="py-4 px-4">
                        <input
                          type="checkbox"
                          checked={selectedItems.includes(m.id)}
                          onChange={() => handleSelectItem(m.id)}
                          className="rounded border-gray-300 text-orange-500"
                        />
                      </td>

                      <td className="py-4 px-4 text-sm text-gray-900">{m.medium_name}</td>
                      <td className="py-4 px-4 text-sm text-gray-600">{formatDate(m.created_at)}</td>
                      <td className="py-4 px-4 text-sm text-gray-600">{m.added_by}</td>

                      <td className="py-4 px-4">
                        <div className="flex items-center gap-2">
                          {/* EDIT */}
                          <button
                            onClick={() => {}}
                            disabled
                            className="p-1 text-gray-300 cursor-not-allowed"
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                            </svg>
                          </button>

                          {/* DELETE */}
                          <button
                            onClick={() => {}}
                            disabled
                            className="p-1 text-gray-300 cursor-not-allowed"
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m-4-6V4a1 1 0 011-1h4a1 1 0 011 1v3" />
                            </svg>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>

          {/* Pagination */}
          <div className="flex items-center justify-between mt-6">
            <div className="flex items-center gap-4">
              <span className="text-sm text-gray-600">Rows per page</span>
              <select
                value={rowsPerPage}
                onChange={(e) => setRowsPerPage(Number(e.target.value))}
                className="border border-gray-300 rounded px-2 py-1 text-sm focus:ring-2 focus:ring-orange-500"
              >
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
              </select>
              <span className="text-sm text-gray-600">Entries</span>
            </div>

            <div className="flex items-center gap-2">
              <button className="p-2 text-gray-400 hover:text-gray-600">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
              </button>
              <button className="w-8 h-8 rounded bg-orange-500 text-white text-sm font-medium">1</button>
              <button className="p-2 text-gray-400 hover:text-gray-600">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>
          </div>
        </div>

        {/* Add Dialog */}
        {isAddDialogOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
            <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md relative">
              <button className="absolute top-2 right-2 text-gray-400 hover:text-gray-700"
                onClick={() => setIsAddDialogOpen(false)}>✖</button>

              <h2 className="text-lg font-semibold mb-4">Add New Order Medium</h2>

              <form onSubmit={handleAddMedium} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Medium Name</label>
                  <input
                    type="text"
                    value={newMedium.name}
                    onChange={(e) => setNewMedium({ name: e.target.value })}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500"
                    placeholder="Enter medium name"
                    required
                  />
                </div>

                <div className="flex justify-end gap-3">
                  <button
                    type="button"
                    onClick={() => setIsAddDialogOpen(false)}
                    className="px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="px-4 py-2 bg-orange-500 text-white rounded-lg"
                  >
                    {isSubmitting ? "Adding..." : "Add Medium"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        <ConfirmationDialog
          isOpen={isDeleteDialogOpen}
          onClose={() => setIsDeleteDialogOpen(false)}
          onConfirm={handleDeleteConfirm}
          title="Delete Medium"
          message={`Are you sure you want to delete "${mediumToDelete?.medium_name}"?`}
          confirmText="Delete"
          type="danger"
        />
      </div>
    </div>
    </>
  );
};

export default AllOrderMedium;
